﻿import React, { useEffect, useState } from "react";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_WITH_FOLLOW_STATUS,
  FETCH_COMPANIES_BY_NAME
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import SearchField from "../common/SearchField";
import { BIBlue, BIRed } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
import InfiniteScroll from "react-infinite-scroll-component";
import AddCompanyModal from "../common/AddCompanyModal";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";
import { AddButton } from "../common/AddButton";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import { CompaniesSkeleton } from "../skeleton/SkeletonView";
import AdContainer from "../common/AdContainer";

const Companies = () => {
  const { loginData, reportSuccess } = useSelector((state) => state?.main);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Companies || {};

  const {
    TEXT_COMPANY_PROFILES = English.Companies.TEXT_COMPANY_PROFILES,
    TEXT_SEARCH_COMPANY = English.Companies.TEXT_SEARCH_COMPANY,
    TEXT_RESULTS = English.Companies.TEXT_RESULTS,
    NO_RESULT = English.Companies.NO_RESULT,
    BUTTON_REPORT = English.Companies.BUTTON_REPORT,
    TEXT_ADD_COMPANY = English.Companies.TEXT_ADD_COMPANY
  } = LanguageData || {};

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nrOfRecords, setNrOfRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pageNr, setPageNr] = useState(1);
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [recordId, setRecordId] = useState([]);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const companyTabs = [
    { value: "all", label: "All Companies" },
    { value: "following", label: "My Following" }
  ];

  useEffect(() => {
    if (reportSuccess !== true) getData(searchTerm, 1, activeTab);
  }, [reportSuccess]);

  const getData = async (searchTerm, pageNo, tabValue = activeTab) => {
    try {
      if (pageNo === 1) {
        setIsLoading(true);
      }
      setAllDataLoaded(true);

      const isFollowingTab = tabValue === "following";
      let res;
      let resData = [];
      let totalRecords = 0;

      if (isFollowingTab) {
        const obj = {
          UserId: loginData?.userInformation?.UserId ?? 0,
          SearchString: searchTerm ?? "",
          PageNumber: pageNo,
          PageSize: 25,
          Manufacturer: false,
          fetchFollowingRecordsOnly: true,
          FetchAllowedRecordsOnly: true,
          IsFollowing: true
        };
        res = await Postrequestcall(FETCH_COMPANIES_WITH_FOLLOW_STATUS, obj, loginData?.accessToken);
        resData = res?.data?.data ?? [];
        totalRecords = res?.data?.nrOfRecords ?? 0;
      } else {
        const obj = {
          PageNr: pageNo,
          NrOfRecPerPage: 25,
          FullSearch: searchTerm ?? "",
          UserId: loginData?.userInformation?.UserId ?? 0,
          IncludeRecordNr: "true",
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: true,
          SearchList: [{}],
          SortList: [{ FieldName: "Name", Direction: "ASC" }]
        };
        res = await Postrequestcall(FETCH_COMPANIES_BY_NAME, obj, loginData?.accessToken);
        resData = res?.data?.data ?? [];
        totalRecords = Number(res?.data?.nrOfRecords ?? res?.data?.RecordNr ?? 0);
      }

      if (pageNo === 1) {
        setData(resData);
      } else {
        setData((prevData) => [...prevData, ...resData]);
      }
      setNrOfRecords(totalRecords);
      setAllDataLoaded(false);
      setIsLoading(false);
    } catch (error) {
      console.log("getData-> Error When fetching Companies: ", error);
      setAllDataLoaded(false);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const getAddress = (item) => {
    let fullAddress = "";
    if (item?.address !== "" && item?.address !== undefined) {
      fullAddress += item?.address;
      fullAddress += ", ";
    }
    if (item?.city !== "" && item?.city !== undefined) {
      fullAddress += item?.city;
      fullAddress += ", ";
    }
    if (item?.province !== "" && item?.province !== undefined) {
      fullAddress += item?.province;
      fullAddress += ", ";
    }
    if (item?.postalCode !== "" && item?.postalCode !== undefined) {
      fullAddress += item?.postalCode;
      fullAddress += ", ";
    }
    if (item?.country !== "" && item?.country !== undefined) {
      fullAddress += item?.country;
    }
    return fullAddress;
  };

  const handleMenuOpen = (event, item) => {
    event.stopPropagation();
    setMoreMenuAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const onCompanyClick = (item) => {
    if (item?.manufacturer) {
      navigate(`/manufacture/${item?.id}`);
    } else {
      navigate(`/company/${item?.id}`);
    }
  };

  const handleViewReport = () => {
    setMoreMenuAnchorEl(null);

    // When the item in Companies list is actually a manufacturer,
    // report it using the same application/screen as the Manufacturers page.
    const isManufacturer = !!recordId?.manufacturer;

    let reportObj = {
      showReport: true,
      name: isManufacturer ? Pages?.manufacturers?.name : Pages?.companies?.name,
      AppScreenId: isManufacturer ? Pages?.manufacturers?.id : Pages?.companies?.id,
      recordId: recordId.id ?? 0,
      isVerified: !!recordId?.verified
    };
    dispatch(setShowReport(reportObj));
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    // Manual search only - user must click the search icon or press Enter
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setPageNr(1);
    setData([]);
    setNrOfRecords(0);
    getData(searchTerm, 1, newValue);
  };

  const handleLoadMore = async () => {
    if (data.length < nrOfRecords) {
      const nextPage = pageNr + 1;
      await getData(searchTerm, nextPage, activeTab);
      setPageNr(nextPage);
    }
  };

  const handleAddPostClick = (event) => {
    event.target.blur();
    setShowAddItemModal(true);
  };

  const handleMenuClose = () => setMoreMenuAnchorEl(null);

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_COMPANY_PROFILES} />
      <Card className="main-content-card">
        <Grid sx={{ pb: 1.5,  display: "flex", alignItems: "center",  justifyContent: "space-between" }}  container spacing={1}>
          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 4 }}>
            <SearchField
              size={"small"}
              value={searchTerm}
              onChange={handleSearchChange}
              onSubmit={() => getData(searchTerm, 1, activeTab)}
              onClear={() => {
                setSearchTerm("");
                setPageNr(1);
                getData("", 1, activeTab);
              }}
              searchIconOutside
              placeholder={TEXT_SEARCH_COMPANY}
            />
          </Grid>
          <Grid sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }} size={{ xs: 12, sm: 12, md: 3, lg: 2 }}>
            <Typography variant="h6" sx={{ color: "text.secondary" }}>
              {nrOfRecords} {TEXT_RESULTS}
            </Typography>
          </Grid>
        </Grid>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}>
            {companyTabs.map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>
        </Box>
        {isLoading ? (
          <>
            <CompaniesSkeleton />
          </>
        ) : (
          <>
            <Box className="main-content-card-list" id="scrollablediv_prodcut">
              {data.length !== 0 ? (
                <InfiniteScroll
                  dataLength={data?.length}
                  next={handleLoadMore}
                  hasMore={data.length < nrOfRecords}
                  loader={
                    !allDataLoaded ? null : (
                      <h4 style={{ display: "flex", justifyContent: "center" }}>
                        <Loader />
                      </h4>
                    )
                  }
                  scrollableTarget="scrollablediv_prodcut">
                  <List disablePadding>
                    <Stack sx={{ gap: 1 }} >
                      {data?.map((item, index) => (
                        <Card
                          key={index}
                          onClick={() => {
                            onCompanyClick(item);
                          }}
                          className="pagelist-content">
                          <ListItem
                            key={index}
                            secondaryAction={
                              <IconButton
                                onClick={(event) => {
                                  handleMenuOpen(event, item);
                                  setRecordId(item);
                                }}>
                                <MoreIcon />
                              </IconButton>
                            }
                            disablePadding>
                            <ListItemButton sx={{ display: "flex", alignItems: "center" }}>
                              <ListItemText
                                primary={
                                  <Stack direction="row"  sx={{ gap: 0.4, alignItems: "center" }}>
                                    {item?.name}
                                    {item?.verified && (
                                      <Tooltip title="This company has been verified" arrow>
                                        <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.2rem" }} />
                                      </Tooltip>
                                    )}
                                  </Stack>
                                }
                                secondary={getAddress(item)}
                                sx={{ flex: 1 }}
                              />
                              <Chip
                                label={item?.manufacturer ? "Manufacturer" : "Company"}
                                size="small"
                                color={item?.manufacturer ? "primary" : "secondary"}
                                variant="outlined"
                                sx={{ fontSize: "0.6rem", flexShrink: 0, ml: 1 }}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Card>
                      ))}
                    </Stack>
                  </List>
                </InfiniteScroll>
              ) : (
                <Box className="empty-data-card">
                  <Emptydata
                    icon={<BusinessCenterIcon className="emptydata-icon" />}
                    firstText={NO_RESULT}
                  />
                </Box>
              )}
            </Box>
          </>
        )}
        <AddButton toolTipText={TEXT_ADD_COMPANY} onAddClick={handleAddPostClick} />
        <AdContainer />
      </Card>
      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}>
          <MenuItem style={{ color: BIRed }} dense onClick={() => handleViewReport()}>
            {BUTTON_REPORT}
          </MenuItem>
        </Menu>
      )}
      {showAddItemModal && (
        <AddCompanyModal
          open={showAddItemModal}
          onClose={() => {
            setShowAddItemModal(false);
          }}
        />
      )}
    </Box>
  );
};

export default Companies;

